import axios from 'api/axios'

/**
 * A helper class for Customer Invoice
 */
export class CustomerInvoiceHelper {
  static #status = {
    '00': 'Pendiente',
    10: 'Invalidada',
    11: 'Validación no disponible',
    12: 'En proceso de validación',
    20: 'Validada',
    30: 'En espera',
    33: 'Pendiente de BackOffice',
    70: 'Aplicada parcial',
    71: 'Aplicada a factura',
    80: 'Error integración',
    90: 'Integrada',
  }

  /**
   * @static
   * @param {string} key
   * @returns {string} returning status
   */
  static getStatus(key) {
    return CustomerInvoiceHelper.#status[key]
  }

  /**
   * @typedef Ficheros
   * @type {Object}
   * @property {string} contenido_fichero // bile content in base64
   * @property {string} nombre_fichero // file name
   * @property {string} tipo_fichero // file mimetype
   */

  /**
   * @typedef CreateCustomerInvoice
   * @type {Object}
   * @property {Array<Ficheros>} ficheros
   * @property {string} idioma
   */

  /**
   * @static
   * @async
   * @param {CreateCustomerInvoice} invoicePayload
   */
  static async createCustomerInvoice({ ficheros, idioma = '01', grupo_balance = '' }) {
    const payload = {
      ficheros,
      idioma,
      grupo_balance,
    }
    try {
      const { data } = await axios.post(`/efactura/ventas/`, payload)
      return data
    } catch (error) {
      throw new Error(`${error.message}`)
    }
  }
}
